module.exports = __webpack_public_path__ + "img/42_4.a705c483.png";